import { useState, useEffect } from 'react';
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MomSysMstProcess ( props ) {

    const [disableDelete, setDisableDelete] = useState();
    const [grid, setGrid] = useState();

    const onInitialized = ( grid ) => {

        setGrid ( grid );
    };

    const checkDeletable = ( items ) => {

        for ( let item of items ) {

            if ( item.processCode === "PR_START" || item.processCode === "PR_END" ) {

                setDisableDelete ( true );
                return;
            }

        }

        setDisableDelete ( false );

    };

    useEffect(() => {

        if (grid) {

            grid.selectionChanged.addHandler((grid, event) => {

                if ( grid.selectedItems && grid.selectedItems[0] ) {

                    checkDeletable ( grid.selectedItems );

                }

            });

            grid.itemsSourceChanged.addHandler((grid, event) => {

                if ( grid.selectedItems && grid.selectedItems[0] ) {

                    checkDeletable ( grid.selectedItems );
                    
                }

            });

        }

    }, [grid]);
    
    return <BasicCrudScreenType id="MomSysMstProcess" table="MomSysMstProcess" view="MomSysZvwProcess" disableDelete={disableDelete} onInitialized={onInitialized} />;

}

export default MomSysMstProcess;
